import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, CirclePlayIcon, Globe2Icon, HeartHandshakeIcon, MousePointerClickIcon, RouteIcon } from 'lucide-react';
import { useCases } from '../../data/useCases';
import { InteriorSlide, SlideBanner } from './SlideShell';
import type { SlideProps } from './SlideShell';
const ICONS = {
  book: BookOpenIcon,
  play: CirclePlayIcon,
  route: RouteIcon,
  cursor: MousePointerClickIcon,
  heart: HeartHandshakeIcon,
  globe: Globe2Icon
} as const;
export function SlideUseCases({}: SlideProps) {
  return <InteriorSlide surface banner={<SlideBanner eyebrow="How it grows" data-id="element-163" data-mp="20gguuo1c1cgs">
          Useful applications can start anywhere — then become shared patterns.
        </SlideBanner>} data-id="element-162" data-mp="24f672damwnyu">
      <motion.header initial={{
      opacity: 0,
      y: 18
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} className="flex flex-shrink-0 items-end justify-between gap-8" data-id="element-164" data-mp="1qh84e55oefz6">
        <div className="min-w-0" data-id="element-165" data-mp="20m8zo2o83ntj">
          <p className="mb-2 text-[clamp(0.7rem,1vw,0.9rem)] font-bold uppercase tracking-[0.2em] text-[var(--brand)]" data-id="element-166" data-mp="20l7m9rjqip8n">
            Snakker in action
          </p>
          <h2 className="text-[clamp(1.9rem,3.6vw,3.3rem)] font-extrabold leading-[1.02] tracking-[-0.04em] text-[var(--fg)]" data-id="element-167" data-mp="1qpdytd4h9bc3">
            One format. <span className="text-[var(--brand)]" data-id="element-168" data-mp="1vnz0lgzdo32n">Many useful jobs.</span>
          </h2>
        </div>
        <p className="hidden max-w-xs flex-shrink-0 text-right text-[clamp(0.78rem,1.05vw,0.98rem)] font-semibold leading-snug text-[var(--muted)] lg:block" data-id="element-169" data-mp="2je1odkw9emvg">
          Different audiences. Different moments. One reusable approach.
        </p>
      </motion.header>

      <div className="mt-[clamp(0.9rem,1.8vw,1.6rem)] grid min-h-0 flex-1 grid-cols-2 gap-[clamp(0.5rem,1vw,0.95rem)] lg:grid-cols-3" data-id="element-170" data-mp="2eddxr0by081r">
        {useCases.map((useCase, index) => {
        const Icon = ICONS[useCase.icon];
        return <motion.article key={useCase.title} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.16 + index * 0.08,
          duration: 0.45
        }} className="group flex min-h-0 overflow-hidden rounded-2xl border border-[var(--fg)]/10 bg-white shadow-sm" data-id="element-171" data-mp="12wxh53onjldb" data-mpi={index}>
              <div className="flex w-[34%] flex-shrink-0 items-center justify-center bg-[var(--brand)]/10" data-id="element-172" data-mp="2qvzvxjuvrnw1">
                <span className="flex h-[clamp(2.8rem,4.8vw,4.75rem)] w-[clamp(2.8rem,4.8vw,4.75rem)] items-center justify-center rounded-2xl bg-[var(--brand)] text-white shadow-lg shadow-[var(--brand)]/20 transition-transform duration-300 group-hover:-rotate-3 group-hover:scale-105" data-id="element-173" data-mp="2lz9h0zutayc7">
                  <Icon className="h-[clamp(1.25rem,2.2vw,2.1rem)] w-[clamp(1.25rem,2.2vw,2.1rem)]" aria-hidden="true" data-id="element-174" data-mp="27yylvkmgyxl8" />
                </span>
              </div>
              <div className="flex min-w-0 flex-1 flex-col justify-center p-[clamp(0.7rem,1.2vw,1.15rem)]" data-id="element-175" data-mp="673jxwq0m7g7">
                <p className="text-[clamp(0.55rem,0.78vw,0.7rem)] font-bold uppercase tracking-[0.16em] text-[var(--brand)]" data-id="element-176" data-mp="dpt9u4t839p4">
                  {useCase.job}
                </p>
                <h3 className="mt-1 text-[clamp(0.9rem,1.35vw,1.3rem)] font-extrabold leading-tight tracking-[-0.025em] text-[var(--fg)]" data-id="element-177" data-mp="nh7gcwjld9rr">
                  {useCase.title}
                </h3>
                <p className="mt-[clamp(0.35rem,0.7vw,0.6rem)] text-[clamp(0.68rem,0.95vw,0.88rem)] leading-snug text-[var(--muted)]" data-id="element-178" data-mp="3qxwkyczm69es">
                  {useCase.line}
                </p>
              </div>
            </motion.article>;
      })}
      </div>
    </InteriorSlide>;
}